import { useAuth, type User } from './NewAuthProvider';

export const useImpersonateUser = (): ((user: User) => void) => {
  const auth = useAuth();

  if (auth.initialized && auth.user && auth.impersonate) {
    return auth.impersonate;
  }

  return () => {
    throw new Error('Impersonation not available - user not authenticated');
  };
};
